import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import * as jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private service: DataService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
  console.log('auth guard')
    const isLoggedIn = this.getSession();

    if (isLoggedIn) {
      return isLoggedIn;
  } else {
      this.service.showMessage('error', 'Session Expired!, Please re-login to catalog information system portal');
      this.router.navigateByUrl('/login');
      return isLoggedIn;
  }


  }
  getSession(): boolean {
    if (localStorage.getItem('email') != null && localStorage.getItem('userId') != null
      && localStorage.getItem('token') != null) {
      //check if token is expired or not
      const token = localStorage.getItem('token');
      if (token) {
        // Decode the token to get its payload
        const tokenPayload = jwt_decode.jwtDecode(token);
        console.log('token : ',tokenPayload);
       
        // Here you can check the expiration or any other claims as needed
        const expirationDate = new Date(tokenPayload.exp * 1000); // Convert seconds to milliseconds
        console.log('Token expires at:', expirationDate);
       
        // Example: Check if the token is expired
        const currentTimestamp = new Date().getTime() / 1000; // Current time in seconds
        console.log(currentTimestamp);
        if (tokenPayload.exp < currentTimestamp) {
          console.log('Token is expired!');
          return false;
        } else {
          console.log('Token is valid');
          return true;
        }
      }
    } else {
      return false;
    }

  }

}
